// ./ru.js
export default {
    子分类: "Подкатегория",
    商品图号: "Номер товара",
    查看详情: "Просмотр",
    图号: "Номер чертежа",
    加入购物车: "В корзину",
    首页: "Главная страница",
    确认退出吗: "Вы уверены, что хотите выйти?",
    确认: "Подтвердить",
    取消: "Отмена",
    我的订单: "Мои заказы",
    购物车: "Корзина",
    总分类: "Общая классификация",
    更多: "Больше",
    默认排序: "Сортировка по умолчанию",
    价格排序: "Сортировка по цене",
    暂无数据: "Нет данных",
    请输入要查询的单号: "Введите номер заказа для поиска",
    查询: "Поиск",
    最近一周: "За последнюю неделю",
    最近一个月: "За последний месяц",
    最近三个月: "За последние три месяца",
    所有日期: "Все даты",
    至: "до",
    确定删除本条商品吗: "Вы уверены, что хотите удалить этот товар?",
    删除: "Удалить",
    已选择: "Выбрано",
    件: "шт.",
    商品合计: "Итоговая сумма товаров",
    下单结算: "Оформить заказ",
    商品信息: "Информация о товаре",
    单价: "Цена за единицу",
    数量: "Количество",
    小计: "Промежуточный итог",
    操作: "Действие",
    共: "Всего",
    件商品: "товаров",
    验证码必须为数字: "Код подтверждения должен быть числом",
    手机号必须为数字: "Номер телефона должен быть числом",
    手机号必须为字母或数字: "Номер телефона должен состоять из букв или цифр",
    账号不能为空: "Логин не может быть пустым",
    密码不能为空: "Пароль не может быть пустым",
    请输入密码: "Введите пароль",
    请输入手机号: "Введите номер телефона",
    用户登录: "Вход пользователя",
    退出登录: "Выход",
    登录中: "Вход...",
    获取验证码: "Получить код подтверждения",
    手机号不能为空: "Номер телефона не может быть пустым",
    请输入关键字: "Введите ключевое слово",
    请输入内容: "Введите содержимое",
    订单编号: "Номер заказа",
    合计: "Итого",
    未审核: "Не проверено",
    下单时间: "Время заказа",
    适用车型: "Подходящие модели",
    详情咨询: "Консультация по деталям",
    描述文字: "Описание",
    商品详情: "Подробности товара",
    商品名称: "Название товара",
    商品规格: "Характеристики товара",
    外文名称: "Иностранный название",
    商品尺寸: "Размеры товара",
    商品体积: "Объем товара",
    商品重量: "Вес товара",
    欢迎来到: "Добро пожаловать",
    网站: "сайт",
    俄文: "Русский",
    英文: "Английский",
    中文: "Китайский язык",
    商品序号: "Артикул",
    俄文名称: "Название на русском",
    英文名称: "Название на английском",
    暂无图片: "Нет изображения",
    重置: "Сброс",
    批量删除: "Массовое удаление",
    请输入商品名称: "Введите название товара",
    今日: "Сегодня",
    昨日: "Вчера",
    本周: "Эта неделя",
    本年: "Этот год",
    本月: "Этот месяц",
    已审核: "Утверждён",
    备注: "Примечание",
    修改: "Изменить",
    备注信息: "Информация о примечании",
    保存: "Сохранить",
    该单据已审核请联系管理员: "Документ уже утверждён, пожалуйста, свяжитесь с администратором.",
    密码登录: "Вход ",
    手机号: "Номер телефона",
    密码: "Пароль",
    登录账号: "Вход ",
}